import { Component, OnInit, ViewChild, ChangeDetectionStrategy, AfterViewInit, ChangeDetectorRef, EventEmitter, Output, Input, SimpleChanges } from '@angular/core';
import { AttendenceExportService } from '../../attendance-export.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { catchError, of } from 'rxjs';
import { PayrollGroupService } from '../../../payroll-group/payroll-group.service';
import { ShopPayrollSettingsService } from '../../../shop-payroll-settings/shop-payroll-settings.service';
import { FilterListItemModel, SearchParam, SearchFilterComponent } from 'src/app/common/components/search-filter/search-filter.component';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { WeeklyResultByStoreReportService } from 'src/app/pages/common/reports/weekly-result-by-store-report/weekly-result-by-store-report.service';
import { EditEmployeePayrollCodeComponent } from './edit-employee-payroll-code/edit-employee-payroll-code.component';
interface PayrollGroup { id: number; code: string; name:string; }
interface ShopPayroll { shop_id: number; name: string; }
interface FinancialYear { year: string; weeks: Week[]; }
interface Week { week_no: number; start_date: string; end_date: string; displayText?: string; }
@Component({
  selector: 'app-attendance-validate-payroll-code',
  standalone: false,
  templateUrl: './validate-payroll-code.component.html',
  styleUrls: ['./validate-payroll-code.component.scss']
})
export class AttendanceValidatePayrollCodeComponent implements OnInit {
  @Input() savedAttendanceHeader: any; // Input to receive saved header when navigating back
  @Output() proceed = new EventEmitter<any>(); // Changed to emit data
  @Output() back = new EventEmitter<void>();
  filterForm: FormGroup;
  payrollGroups: PayrollGroup[] = [];
  filteredPayrollGroups: PayrollGroup[] = [];
  shopPayrolls: ShopPayroll[] = [];
  filteredShopPayrolls: ShopPayroll[] = [];
  years: number[] = [];
  weeks: Week[] = [];
  financialYears: FinancialYear[] = [];
  selectedYear: any;
  curFinYear!: string;
  dummyEmployeeGroups: any[] = [];
  showDummy: boolean = false;
  dummyPayload: any = null;
  showProceedComponent = false;
  isProceeding = false;

  filter: FilterListItemModel[] = [
    { title: "Code", column: "code" },
    { title: "Fixed Pay", column: "fixed_pay" },
    { title: "Payroll Code", column: "payroll_code" }
  ];
  searchColumFilter: SearchParam = {};
  displayedColumns: string[] = ['sl', 'shops', 'name', 'action'];
  dataSource = new MatTableDataSource<any>([]);
  isLoading = false;
  showValidation = false;
  searched = false;
  showPayrollProceed: boolean = false;
  selectedStartDate: string | null = null;   
  selectedEndDate: string | null = null;     
  attendanceHeader: any = null;              

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('searchFilter') searchFilter!: SearchFilterComponent;

  constructor(
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private attendenceExportService: AttendenceExportService,
    private payrollGroupService: PayrollGroupService,
    private shopPayrollSettingsService: ShopPayrollSettingsService,
    private weeklyResultByStoreReportService: WeeklyResultByStoreReportService,
    private router: Router,
    private dialog: MatDialog

  ) {
    this.filterForm = this.fb.group({
      payroll_group_id: [null],
      shop_id: [null],
      status: ['1'],
      year: [null],
      week_no: [null]
    });
  }

  private dropdownsLoaded = false;
  private financialYearsLoaded = false;

  ngOnInit(): void {
    this.loadDropdowns();
    this.loadData();
    this.dataSource.sort = this.sort;
    this.showDummy = true;
  }

  private tryRestoreState() {
    if (this.dropdownsLoaded && this.financialYearsLoaded) {
      const savedFilterState = sessionStorage.getItem('attendance_export_filter_state');
      if (savedFilterState) {
        try {
          const state = JSON.parse(savedFilterState);
          this.filterForm.patchValue(state.filterForm);
          this.selectedYear = state.filterForm.year;
          this.attendanceHeader = state.attendanceHeader;
          // Don't automatically restore showPayrollProceed - let validation determine it
          this.showPayrollProceed = false;
          this.showDummy = state.showDummy;

          // Patch payroll group
          if (state.filterForm.payroll_group_id) {
            const payrollGroup = this.payrollGroups.find(g =>
              g.id === state.filterForm.payroll_group_id.id ||
              g.code === state.filterForm.payroll_group_id.code
            );
            if (payrollGroup) {
              this.filterForm.get('payroll_group_id')?.setValue(payrollGroup, { emitEvent: false });
            }
          }
          // Patch year and week
          if (state.filterForm.year) {
            this.filterForm.get('year')?.setValue(state.filterForm.year, { emitEvent: false });
            this.selectedYear = state.filterForm.year;
            const selectedFinYear = this.financialYears.find(fy => fy.year === String(state.filterForm.year));
            if (selectedFinYear) {
              this.weeks = selectedFinYear.weeks.map((week: Week) => ({
                ...week,
                displayText: `${this.padWeekNumber(week.week_no)} (${week.start_date} - ${week.end_date})`
              }));
              if (state.filterForm.week_no) {
                this.filterForm.get('week_no')?.setValue(state.filterForm.week_no, { emitEvent: false });
              }
            }
          }
          sessionStorage.removeItem('attendance_export_filter_state');
        } catch {}
      } else {
        setTimeout(() => {
          this.restoreFormState();
        }, 500);
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['savedAttendanceHeader'] && !changes['savedAttendanceHeader'].firstChange) {
      this.restoreFormState();
    }
  }

  restoreFormState(): void {
    if (this.savedAttendanceHeader) {
      // Find the payroll group object from the code
      const payrollGroup = this.payrollGroups.find(g => g.code === this.savedAttendanceHeader.payroll_group_code);
      
      if (payrollGroup) {
        // First set year to load weeks
        this.selectedYear = this.savedAttendanceHeader.year;
        this.filterForm.patchValue({
          payroll_group_id: payrollGroup,
          year: this.savedAttendanceHeader.year
        });
        
        // Load weeks for the year
        const selectedFinYear = this.financialYears.find(fy => fy.year === this.selectedYear.toString());
        if (selectedFinYear) {
          this.weeks = selectedFinYear.weeks.map((week: Week) => ({
            ...week,
            displayText: `${this.padWeekNumber(week.week_no)} (${week.start_date} - ${week.end_date})`
          }));
        }
        
        // Now set the week number after weeks are loaded
        setTimeout(() => {
          this.filterForm.patchValue({
            week_no: this.savedAttendanceHeader.weekNo
          });
          
          // Don't automatically show proceed button - let user validate again
          this.showPayrollProceed = false;
          this.showDummy = true;
        }, 100);
      }
    }
  }
  
  loadDropdowns() {
    const requestData = {
      search: {
        filters: {
          column: [],
          scope: { limit: 100, offset: 0 },
        },
        sort: [{ column: "code", order: "asc" }],
      },
    };

    this.payrollGroupService.getList(requestData).pipe(
      catchError(err => { console.error('Error loading payroll groups:', err); return of({ status: 'ERROR', data: { payroll_groups: [] } }); })
    ).subscribe(res => {
      if (res.status === 'SUCCESS') {
        this.payrollGroups = res.data.payroll_groups || [];
        this.filteredPayrollGroups = this.payrollGroups.slice();
      }
      this.dropdownsLoaded = true;
      this.tryRestoreState();
    });

    this.shopPayrollSettingsService.getList(requestData).pipe(
      catchError(err => { console.error('Error loading shop payrolls:', err); return of({ status: 'ERROR', data: { shop_payroll_settings: [] } }); })
    ).subscribe(res => {
      if (res.status === 'SUCCESS') {
        this.shopPayrolls = res.data.shop_payroll_settings || [];
        this.filteredShopPayrolls = this.shopPayrolls.slice();
      }
    });
  }

  filterPayrollGroups(value: string) {
    const filterValue = value?.trim().toLowerCase() || '';
    this.filteredPayrollGroups = this.payrollGroups.filter(group =>
      group.code.toLowerCase().includes(filterValue)
    );
  }

  getPayrollGroupName(id: any): string {
    const found = this.payrollGroups.find(g => g.id === id);
    return found ? found.code : '';
  }

  clearPayrollGroup() {
    this.filterForm.get('payroll_group_id')?.setValue(null);
    this.filteredPayrollGroups = this.payrollGroups.slice();
    this.filterForm.get('shop_id')?.setValue(null);
    this.filteredShopPayrolls = this.shopPayrolls.slice();
    this.showDummy = true;
    this.dummyEmployeeGroups = [];
  }

  selectPayrollGroup(group: PayrollGroup) {
    this.filterForm.get('payroll_group_id')?.setValue(group);
    this.showValidation = false;
    this.showDummy = false;
    this.dummyEmployeeGroups = [];
  }

  getPayrollGroupDisplay(group: any): string {
    return group ? `(${group.code}) ${group.name}` : '';
  }

  filterShopPayrolls(value: string) {
    const filterValue = value?.trim().toLowerCase() || '';
    this.filteredShopPayrolls = this.shopPayrolls.filter(shop =>
      shop.name.toLowerCase().includes(filterValue)
    );
  }

  getShopName(id: any): string {
    const found = this.shopPayrolls.find(s => s.shop_id === id);
    return found ? found.name : '';
  }

  clearShopPayroll() {
    this.filterForm.get('shop_id')?.setValue(null);
    this.filteredShopPayrolls = this.shopPayrolls.slice();
    this.showDummy = true;
    this.dummyEmployeeGroups = [];
  }

  selectShopPayroll(id: any) {
    if (!this.filterForm.value.payroll_group_id) {
      this.showValidation = true;
      this.filterForm.get('shop_id')?.setValue(null);
      return;
    }
    this.filterForm.get('shop_id')?.setValue(id);
    this.showValidation = false;
    this.loadList();
    this.showDummy = false;
    this.dummyEmployeeGroups = [];
  }

  getCurrentWeek(weeks: Week[]): Week | undefined {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return weeks.find(week => {
      const startDate = new Date(week.start_date);
      const endDate = new Date(week.end_date);
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);

      return today >= startDate && today <= endDate;
    });
  }

  padWeekNumber(weekNo: number): string {
    return weekNo.toString().padStart(2, '0');
  }

  onYearChange(): void {
    this.selectedYear = this.filterForm.get('year')?.value;
    const selectedFinYear = this.financialYears.find(fy => fy.year === this.selectedYear);

    if (selectedFinYear) {
      this.weeks = selectedFinYear.weeks.map((week: Week) => ({
        ...week,
        displayText: `${this.padWeekNumber(week.week_no)} (${week.start_date} - ${week.end_date})`
      }));

      if (this.weeks.length > 0) {
        this.filterForm.get('week_no')?.setValue(this.weeks[0].week_no);
      }
    } else {
      this.weeks = [];
      this.filterForm.get('week_no')?.setValue(null);
    }
    this.showDummy = true;
    this.dummyEmployeeGroups = [];
    
  }

  buildRequestData(): any {
    return {
      search: {
        filters: {
          simpleSearch: [],
          advSearch: [],
          scope: {
            limit: "100",
            offset: "0"
          }
        },
        sort: [
          {
            column: "wd.year",
            order: "desc"
          }
        ]
      }
    };
  }

  loadData(): void {
    let requestData = this.buildRequestData();
    this.weeklyResultByStoreReportService.getWeekNoList(requestData).subscribe(response => {
      if (response.status === 'SUCCESS') {
        this.financialYears = response.data.finYears;
        this.years = this.financialYears.map(fy => parseInt(fy.year));

        if (!this.filterForm.get('year')?.value) {
          this.curFinYear = response.data.curFinYear;
          if (this.curFinYear) {
            const yearValue = parseInt(this.curFinYear);
            this.filterForm.get('year')?.setValue(yearValue, { emitEvent: false });

            const currentFinYear = this.financialYears.find(fy => parseInt(fy.year) === yearValue);
            if (currentFinYear) {
              this.weeks = currentFinYear.weeks.map((week: Week) => ({
                ...week,
                displayText: `${this.padWeekNumber(week.week_no)} (${week.start_date} - ${week.end_date})`
              }));
              const currentWeek = this.getCurrentWeek(this.weeks);
              if (currentWeek) {
                this.filterForm.get('week_no')?.setValue(currentWeek.week_no);
              } else if (this.weeks.length > 0) {
                this.filterForm.get('week_no')?.setValue(this.weeks[0].week_no);
              }
            }
          }
        }
      }
      this.financialYearsLoaded = true;
      this.tryRestoreState();
    });
  }

onValidateClick() {
  if (this.filterForm.invalid) return;
  const formValue = this.filterForm.value;

  const payload = {
    payroll_group_id: formValue.payroll_group_id?.id,
    year: formValue.year,
    weekNo: formValue.week_no,
  };
      // determine week start/end from weeks array
    const selWeek = this.weeks.find(w => w.week_no === formValue.week_no);
    this.selectedStartDate = selWeek?.start_date || null;
    this.selectedEndDate = selWeek?.end_date || null;

    // build header object you asked for
    const header = {
      payroll_group_code: formValue.payroll_group_id?.code || (formValue.payroll_group_id?.id ? this.getPayrollGroupName(formValue.payroll_group_id?.id) : null),
      period: `${formValue.year}-${(parseInt(formValue.year || 0) + 1).toString().slice(-2)}`, // optional format example
      year: formValue.year,
      weekNo: formValue.week_no,
      start_date: this.selectedStartDate,
      end_date: this.selectedEndDate
    };

    // set local var to pass as input
    this.attendanceHeader = header;
    // Save to sessionStorage AFTER setting the value
    sessionStorage.setItem('attendance_export_header', JSON.stringify(header));
  this.isLoading = true;
  this.attendenceExportService.getList(payload).subscribe({
    next: (response) => {
      this.isLoading = false;
      if (response.status === 'SUCCESS' && Array.isArray(response.data?.payroll_attendance)) {
        this.dummyEmployeeGroups = this.groupByShopname(response.data.payroll_attendance);

        // Show Proceed message if array is empty
        this.showPayrollProceed = response.data.payroll_attendance.length === 0;
      } else {
        this.dummyEmployeeGroups = [];
        this.showPayrollProceed = false;
      }
      this.showDummy = true;
      this.cdr.markForCheck();
    },
    error: (err) => {
      this.isLoading = false;
      this.dummyEmployeeGroups = [];
      this.showPayrollProceed = false;
      this.showDummy = true;
      this.cdr.markForCheck();
    }
  });
}

private groupByShopname(payrollAttendance: any[]): any[] {
  const groups: { [shopname: string]: any[] } = {};
  payrollAttendance.forEach(emp => {
    if (!emp.shopname) return; // skip if no shopname
    if (!groups[emp.shopname]) {
      groups[emp.shopname] = [];
    }
    groups[emp.shopname].push(emp);
  });
  return Object.keys(groups).map(shopname => ({
    groupName: shopname,
    employees: groups[shopname]
  }));
}

  onFilterApplied(columFilter: any): void {
    this.searchColumFilter = columFilter;
    this.loadList();
    this.showDummy = false;
    this.dummyEmployeeGroups = [];
  }

  buildListRequestData(): any {
    const { payroll_group_id, shop_id, status, year, week_no } = this.filterForm.value;
    let advSearch: any[] = [...(this.searchColumFilter.advSearch || [])];

    if (payroll_group_id) advSearch.push({ column: 'payroll_group_id', value: payroll_group_id, operator: '=' });
    if (shop_id) advSearch.push({ column: 'shop_id', value: shop_id, operator: '=' });
    if (status) advSearch.push({ column: 'status', value: status, operator: '=' });
    if (year) advSearch.push({ column: 'year', value: year, operator: '=' });
    if (week_no) advSearch.push({ column: 'week_no', value: week_no, operator: '=' });

    return {
      search: {
        filters: {
          simpleSearch: this.searchColumFilter.freeSearch || [],
          advSearch,
          scope: {
            limit: 1000,
            offset: 0
          }
        },
        sort: [{ column: 'name', order: 'asc' }]
      }
    };
  }

  loadList() {
    this.searched = true;
    const formValue = this.filterForm.value;
    if (!formValue.year || !formValue.week_no) {
      this.dataSource.data = [];
      return;
    }
    this.isLoading = true;
    const requestData = this.buildListRequestData();
    this.attendenceExportService.getList(requestData).pipe(
      catchError(err => { 
        console.error('Error loading list:', err); 
        return of({ status: 'ERROR', data: { staff_payroll_groups: [] } }); 
      })
    ).subscribe(res => {
      if (res.status === 'SUCCESS') {
        this.dataSource.data = res.data.staff_payroll_groups || [];
      } else {
        this.dataSource.data = [];
      }
      this.isLoading = false;
    });
  }



  onEdit(emp: any, formValue: any) {
    const sessionData = {
      employee_id: emp.employee_id,
      shop_id: emp.shopid,
      payroll_group_id: formValue.payroll_group_id?.id,
      year: formValue.year,
      weekNo: formValue.week_no
    };
    sessionStorage.setItem('employee-payroll-edit-data', JSON.stringify(sessionData));
    console.log('Session Data Stored:', sessionData);

    this.dialog.open(EditEmployeePayrollCodeComponent, {
      width: '900px',
      data: sessionData // pass your sessionData object here
    });
  }
onProceed() {
  // Build payload and header, then emit to parent
  const formValue = this.filterForm.value;
  const selWeek = this.weeks.find(w => w.week_no === formValue.week_no);
  
  const payload = {
    payroll_group_id: formValue.payroll_group_id?.id,
    year: formValue.year,
    weekNo: formValue.week_no
  };

  const header = {
    payroll_group_code: formValue.payroll_group_id?.code || (formValue.payroll_group_id?.id ? this.getPayrollGroupName(formValue.payroll_group_id?.id) : null),
    period: `${formValue.year}-${(parseInt(formValue.year || 0) + 1).toString().slice(-2)}`,
    year: formValue.year,
    weekNo: formValue.week_no,
    start_date: selWeek?.start_date || null,
    end_date: selWeek?.end_date || null
  };

  // Save to sessionStorage
  sessionStorage.setItem('attendance_export_header', JSON.stringify(header));

  // Emit both payload and header to parent
  this.proceed.emit({ payload, header });
}

onExportAttendanceProceed() {
  // Build payload from form values
  const formValue = this.filterForm.value;
  const payload = {
    payroll_group_id: formValue.payroll_group_id?.id,
    year: formValue.year,
    weekNo: formValue.week_no
  };

  this.attendenceExportService.exportAttendance(payload).subscribe({
    next: (response) => {
      if (response.status === 'SUCCESS') {
        this.proceed.emit(); // Notify parent to proceed
      } else {
        // Optionally show error message
        // this.snackBarService.openSnackBar({ message: response.message || 'Export failed', title: 'Error', type: 'error' });
      }
    },
    error: (err) => {
      // Optionally show error message
      // this.snackBarService.openSnackBar({ message: 'Export failed due to server error', title: 'Error', type: 'error' });
    }
  });
}

onBack() {
  // Save current filter state to sessionStorage before navigating back
  sessionStorage.setItem('attendance_export_filter_state', JSON.stringify({
    filterForm: this.filterForm.value,
    attendanceHeader: this.attendanceHeader,
    showPayrollProceed: this.showPayrollProceed,
    showDummy: this.showDummy
  }));
  this.back.emit();
}
}
